import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Row, Col, Button } from "reactstrap";

import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockHead, BlockHeadContent, BlockTitle, PreviewAltCard } from "../../components/Component";

import MyInput from "../../MyComp/UI/form/MyInput";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import Status from "../../MyComp/UI/form/Status";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";

const SectionBranding = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        setError,
        getValues,
        formState: { errors },
    } = useForm({
        defaultValues: {
            section: "appointment",
        },
    });

    const [loading, setLoading] = useState(false);

    const genderOption = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
    ];

    const onFormSubmit = (formData) => {
        console.log("Form Data 👉", formData);
    };
    const sectionOptions = [
        { label: "Diagnostic", value: "diagnostic" },
        { label: "Pharmacy", value: "pharmacy" },
        { label: "Consultation", value: "consultation" },
        { label: "Appointment", value: "appointment" },
    ];

    return (
        <>
            <Head title="Section Branding" />
            <Content>
                <BlockHead size="sm">
                    <BlockHeadContent>
                        <BlockTitle tag="h3">Section Branding</BlockTitle>
                    </BlockHeadContent>
                </BlockHead>

                <Block>
                    <PreviewAltCard>
                        <Form onSubmit={handleSubmit(onFormSubmit)}>
                            <Row>
                                <Col md="4">

                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="App button text"
                                        name="app_button_text"
                                        placeholder="Enter app button text"
                                        required
                                    />
                                </Col>
                                <Col md="4">
                                    <MyDate
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Visible from"
                                        name="visible_from"
                                        placeholder="Select visible from date"
                                        required
                                    />
                                </Col>
                                <Col md="4">
                                    <MyDate
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Visible to"
                                        name="visible_to"
                                        placeholder="Select visible to date"
                                        required
                                    />
                                </Col>
                                <Col md="8" className="mb-3">
                                    {/* Label same as other fields */}
                                    <label className="form-label" style={{ fontWeight: 500 }}>
                                        Section <span style={{ color: "red" }}>*</span>
                                    </label>

                                    {/* Container same feel as input box */}
                                    <div
                                        style={{
                                            border: "1px solid #dbdfea",
                                            borderRadius: "6px",
                                            padding: "12px",
                                            background: "#fff",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {sectionOptions.map((item) => {
                                                const selected = watch("section", "appointment") === item.value;

                                                return (
                                                    <label
                                                        key={item.value}
                                                        style={{
                                                            padding: "10px 16px",
                                                            borderRadius: "8px",
                                                            border: selected
                                                                ? "2px solid #53b556"
                                                                : "1px solid #dbdfea",
                                                            background: selected
                                                                ? "#E8F5E9"   // ✅ light green instead of purple
                                                                : "#fff",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            marginBottom: 0,
                                                        }}
                                                    >
                                                        <input
                                                            type="radio"
                                                            value={item.value}
                                                            {...register("section", { required: true })}
                                                            style={{
                                                                cursor: "pointer",
                                                                accentColor: "#53b556",
                                                            }}
                                                        />

                                                        <span style={{ fontWeight: 500, color: "#526484" }}>
                                                            {item.label}
                                                        </span>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* Error same as other fields */}
                                    {errors.section && (
                                        <span className="invalid" style={{ color: "#e85347", fontSize: "12px" }}>
                                            Section is required
                                        </span>
                                    )}
                                </Col>
    
                                <Col md="6">
                                    <Button color="primary" type="submit" disabled={loading} style={{ marginTop: "30px" }}>
                                        Submit
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </PreviewAltCard>
                </Block>
            </Content>
        </>
    );
};

export default SectionBranding;